import {USPsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {
  BasketSection,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  Image,
  UnstyledLink,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

import {useTranslation} from '@aboutyou/i18n';
import {getAdjustedCdnUrl, isCaseTypeCheck} from '@aboutyou/utils';

const MAX_USPS_COUNT = 3;

export const BasketUspsView: React.FC<USPsSection> = ({type}) => {
  const {t} = useTranslation();

  if (!isCaseTypeCheck('usp', type) || !type.usp.usps.length) {
    return null;
  }

  const {usps} = type.usp;

  return (
    <BasketSection>
      <UspList data-testid="basketUsps">
        <UspTitle>{t('Your benefits')}</UspTitle>
        {usps.slice(0, MAX_USPS_COUNT).map(item => {
          const content = (
            <>
              <StyledImage
                src={getAdjustedCdnUrl(item.image.url, {
                  bg: COLORS.Grey4,
                })}
                alt={item.image.description}
                breakpoints={[]}
                widths={[75]}
                ratio={'1:1'}
                loading="lazy"
              />
              <StyledLabel>{item.label}</StyledLabel>
            </>
          );

          return item.href ? (
            <UspTileLink key={item.label} to={item.href} aria-label={undefined}>
              {content}
            </UspTileLink>
          ) : (
            <UspTile key={item.label}>{content}</UspTile>
          );
        })}
      </UspList>
    </BasketSection>
  );
};

const UspTitle = styled.h2`
  margin: 0 0 1rem;
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.bold};
`;

const UspList = styled.div`
  padding: 1rem;
`;

const uspItemCss = css`
  display: flex;
  padding: 0.5rem;
  align-items: center;
  box-sizing: border-box;
  text-transform: uppercase;
  font-size: ${FONT_SIZES.px10};
  background: ${COLORS.Grey4};
  color: #828282; // 2nd shade of COLORS.Grey1
  margin-bottom: 2px;
`;

const UspTileLink = styled(UnstyledLink)`
  ${uspItemCss}
`;

const UspTile = styled.div`
  ${uspItemCss}
`;

const StyledImage = styled(Image)`
  width: 16px;
  height: 16px;
  margin-right: 0.5rem;
`;

const StyledLabel = styled.b`
  font-weight: ${FONT_WEIGHTS.mediumBold};
`;
